import { defineRecipe } from '@chakra-ui/react'

export const input = defineRecipe({
	variants: {
		variant: {
			unstyled: {
				bg: 'transparent',
				border: 'none',
				outline: 'none',
				boxShadow: 'none',
				px: 0,
				_focus: {
					boxShadow: 'none',
					outline: 'none'
				},
				_focusVisible: {
					boxShadow: 'none',
					outline: 'none'
				}
			}
		}
	}
})
